import {SEO_PUBLISHED_CITIES, geoBestRestaurantsPath, geoCityPath} from './geoRoutes';

export const citiesWithPublishedGuides = SEO_PUBLISHED_CITIES.map((geo) => ({
    name: geo.cityName,
    countryName: geo.countryName,
    hubHref: geoCityPath(geo),
    bestRestaurantsHref: geoBestRestaurantsPath(geo),
}));
